<template>
  <validation-provider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    :vid="$attrs.vid"
  >
    <v-text-field
      v-if="inputType === 'input'"
      :loading="loading"
      :id="id"
      :label="name"
      :placeholder="placeholder || name"
      :error-messages="errors"
      :disabled="disabled"
      outlined
      :counter="counter"
      :type="type"
      :dense="dense"
      :value="value"
      :maxlength="maxlength"
      @keyup="handleUp"
      @input="handleInput"
      @change="handleChange"
      :append-icon="icon"
      @click:append="handleAppendClick"
    ></v-text-field>
    <v-file-input
      v-else-if="inputType === 'file'"
      v-bind="$attrs"
      :loading="loading"
      :id="id"
      :placeholder="placeholder || name"
      :error-messages="errors"
      :disabled="disabled"
      outlined
      :dense="dense"
      :value="value"
      @input="handleInput"
      @change="handleInput"
      :append-icon="icon"
      @click:append="handleAppendClick"
    ></v-file-input>
    <v-textarea
      v-else
      v-bind="$attrs"
      :loading="loading"
      :id="id"
      :label="name"
      :placeholder="placeholder || name"
      :error-messages="errors"
      :disabled="disabled"
      :maxlength="maxlength"
      outlined
      :counter="counter"
      :type="type"
      :dense="dense"
      :value="value"
      @input="handleInput"
      @change="handleChange"
      :append-icon="icon"
      @click:append="handleAppendClick"
    ></v-textarea>
  </validation-provider>
</template>

<script>
import VerifyStrongPassword from "../../helpers/validators/verifyStrongPassword";
import verifyFileSize from "../../helpers/validators/verifyFileSize";
import EmployerNumberValidator from "../../helpers/validators/employerNumber.validator";
import {
  required,
  email,
  max,
  ext,
  confirmed,
  min
} from "vee-validate/dist/rules";
import { extend, ValidationProvider } from "vee-validate";

extend("required", {
  ...required,
  message: "Favor informar {_field_}."
});

extend("confirmed", {
  ...confirmed,
  message: "As senhas não coincidem."
});

extend("max", {
  ...max,
  message: "{_field_} não pode ser maior que {length} caracteres"
});

extend("min", {
  ...min,
  message: "{_field_} não pode ser menor que {length} caracteres"
});

extend("email", {
  ...email,
  message: "E-mail inválido."
});

extend("ext", {
  ...ext,
  message: "Tipo de arquivo inválido."
});

extend("employerNumber", {
  ...EmployerNumberValidator,
  message: "{_field_} inválido."
});

extend("strongPassword", {
  ...VerifyStrongPassword,
  message:
    "{_field_} deve conter pelo menos 6 caracteres entre letras e números."
});

extend("sizeFile", {
  ...verifyFileSize,
  message: "{_field_} deve conter no máximo 10mb."
});

export default {
  components: {
    ValidationProvider
  },
  props: {
    name: {
      type: String
    },
    rules: {
      type: [String, Object]
    },
    id: {
      type: String
    },
    value: [String, Number, File],
    maxlength: [String, Number],
    counter: {
      type: Number
    },
    icon: {
      type: String
    },
    dense: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String
    },
    inputType: {
      type: String,
      default: "input"
    },
    placeholder: {
      type: String
    }
  },
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    },
    handleAppendClick(e) {
      this.$emit("handlerAppendClick", e);
    },
    handleChange(e) {
      this.$emit("handleChange", e);
    },
    handleUp(e) {
      this.$emit("handleUp", e);
    }
  }
};
</script>

<style></style>
